import Skeleton from "@mui/material/Skeleton";
import { DreamSearchResult } from "./DreamSearchResult";
import { DreamSearchResultsContainer } from "./DreamSearchResults";

export const DreamSearchSkeletonItem = () => (
  <DreamSearchResult
    i={0}
    title={<Skeleton variant="rounded" sx={{ height: "1.4rem", width: "75%" }} />}
    content={<Skeleton variant="rounded" height={94} />}
    eventName={null}
  />
);

export const DreamSearchSkeletonItems = ({ itemCount = 8 }: { itemCount?: number }) =>
  [...Array(itemCount)].map((_e, idx) => <DreamSearchSkeletonItem key={idx} />);

export const DreamSearchResultSkeletons = ({ itemCount = 8 }: { itemCount?: number }) => (
  <DreamSearchResultsContainer>
    {[...Array(itemCount)].map((_e, idx) => (
      <DreamSearchSkeletonItem key={idx} />
    ))}
  </DreamSearchResultsContainer>
);
